import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState, useCallback, useMemo } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { motion, AnimatePresence } from "framer-motion";
import { Navigation } from "./components/Navigation";
import { HeroSection } from "./components/HeroSection";
import { ExperienceSection } from "./components/ExperienceSection";
import { GuideSection } from "./components/GuideSection";
import { PackagesSection } from "./components/PackagesSection";
import { SafetySection } from "./components/SafetySection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { GallerySection } from "./components/GallerySection";
import { FAQSection } from "./components/FAQSection";
import { FooterSection } from "./components/FooterSection";

const WHATSAPP_LINK = "https://wa.me/5521972232170";

const LandingPage = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = useCallback((container) => {
    console.log("Particles loaded", container);
  }, []);

  const options = useMemo(
    () => ({
      background: {
        color: {
          value: "transparent",
        },
      },
      fpsLimit: 60,
      interactivity: {
        events: {
          onHover: {
            enable: true,
            mode: "grab",
          },
        },
        modes: {
          grab: {
            distance: 140,
            links: {
              opacity: 0.5,
            },
          },
        },
      },
      particles: {
        color: {
          value: ["#00F0FF", "#D900FF", "#FFD700"],
        },
        links: {
          color: "#00F0FF",
          distance: 150,
          enable: true,
          opacity: 0.2,
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: true,
          speed: 0.8,
          straight: false,
        },
        number: {
          density: {
            enable: true,
            area: 1000,
          },
          value: 50,
        },
        opacity: {
          value: 0.5,
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 1, max: 3 },
        },
      },
      detectRetina: true,
    }),
    []
  );

  return (
    <div className="relative min-h-screen bg-jungle-dark">
      {/* Noise Overlay */}
      <div className="noise-overlay"></div>
      
      {/* Particles Background */}
      {init && (
        <Particles
          id="tsparticles"
          particlesLoaded={particlesLoaded}
          options={options}
        />
      )}

      {/* Main Content */}
      <div className="main-content">
        <Navigation whatsappLink={WHATSAPP_LINK} />
        
        <AnimatePresence>
          <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <HeroSection whatsappLink={WHATSAPP_LINK} />
            <ExperienceSection />
            <GuideSection whatsappLink={WHATSAPP_LINK} />
            <PackagesSection whatsappLink={WHATSAPP_LINK} />
            <SafetySection />
            <TestimonialsSection />
            <GallerySection />
            <FAQSection />
            <FooterSection whatsappLink={WHATSAPP_LINK} />
          </motion.main>
        </AnimatePresence>
      </div>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
